

















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<PriceBrief>({
    name: 'PriceBrief',
})
export default class PriceBrief extends Vue{
    @Prop({ type: Number, required: true }) value!: number;
}
